import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from '../../../components/components.module';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../../../../environments/environment';
import { FirebaseAuthService } from './firebase-auth.service';
import { FirebaseProfilePageGuard } from './firebase-profile-can-activate.guard';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
  //  {
  //   path: "",
  //   redirectTo: "auth/sign-in",
  //   pathMatch: "full"
  // }, 
  {
    path: "auth",
    children: [
      {
        path: 'sign-in',
        children: [
          {
            path: '',
            loadChildren: () => import('./sign-in/firebase-sign-in.module').then(m => m.FirebaseSignInPageModule)
          },
        ]
      },
      {
        path: 'sign-up',
        loadChildren: () => import('./sign-up/firebase-sign-up.module').then(m => m.FirebaseSignUpPageModule)
      },        
]
    },  
  //   {
  //   path: 'sign-in',
  //   loadChildren: () => import('./sign-in/firebase-sign-in.module').then(m => m.FirebaseSignInPageModule)
  // },
  {
    path: 'profile',
    loadChildren: () => import('./profile/firebase-profile.module').then(m => m.FirebaseProfilePageModule)
  }
];

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ComponentsModule,
    RouterModule.forChild(routes),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    //TranslateModule
  ],
  providers: [FirebaseAuthService, FirebaseProfilePageGuard]
})
export class FirebaseAuthModule {
  constructor(@Optional() @SkipSelf() parentModule?: FirebaseAuthModule) {
    if (parentModule) {
      throw new Error(
        'FirebaseAuthModule is already loaded. Import it in the AppModule only');
    }
  }
}
